import { render, staticRenderFns } from "./AutomaticConfiguration.vue?vue&type=template&id=bee247b8"
import script from "./AutomaticConfiguration.vue?vue&type=script&lang=js"
export * from "./AutomaticConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports